export default __webpack_public_path__ + "static/Plate_2x2_Off_White_RGB-353e5cbb18f8e6765f3f6ef4da0c27c1.svg";